@if (displayStyle() === ButtonStyle.RAISED) {
    <svg class="underlay">
        <defs>
            <filter id="underlay-black-white-threshold" color-interpolation-filters="sRGB">
                <feColorMatrix type="matrix" values="
                                0.3333 0.3333 0.3333 0 0
                                0.3333 0.3333 0.3333 0 0
                                0.3333 0.3333 0.3333 0 0
                                0      0      0      1 0"/>
                <feComponentTransfer>
                    <feFuncR type="discrete" tableValues="1 1 1 1 0.65"/>
                    <feFuncG type="discrete" tableValues="1 1 1 1 0.65"/>
                    <feFuncB type="discrete" tableValues="1 1 1 1 0.65"/>
                </feComponentTransfer>
            </filter>
        </defs>
        <rect width="100%" height="100%"/>
    </svg>
}
<div class="face" woa-touchable [ngClass]="{'hovered': hovered()}">
    <div class="content">
        <div class="content-main">
            @if (icon()) {
                <woa-icon class="content-main-icon" [name]="icon()"></woa-icon>
            }
            <ng-content></ng-content>
            <div class="content-main-label">
                <div class="content-main-label-text" [innerHTML]="label() | translate: translationParams() | html"></div>
            </div>
            <ng-content select="[slot=after-label]"></ng-content>
        </div>
    </div>
    @if (showSpinner()) {
        <woa-spinner class="face-spinner"></woa-spinner>
    }
</div>
